@if(volunteerDetails(); as volunteer) {
<div class="lead-volunteer-application-overview-content-dialog-part row h-100">
	<div class="col-lg-6 mb-2">
		<div class="bg-light rounded shadow-sm h-100">
			<div class="pt-2 ps-1">
				<h5>
					<span class="badge bg-secondary-subtle text-black px-3 py-2">
						Status: {{volunteer.status}}
					</span>
				</h5>
			</div>

			<div class="p-3 pt-0">
				<table class="table table-borderless mb-4">
					<tbody>
						<tr>
							<th class="w-50">Available as of:</th>
							<td>{{volunteer.availableStart ?? 'N/A'}}</td>
						</tr>
					</tbody>
				</table>

				<div class="row">
					<div class="col-md-12">
						<p>Willing to volunteer in:</p>
						<ul>
							@for (lang of volunteer.languages; track lang) {
							<li>{{lang}}</li>
							}
						</ul>
						<p>Interested in:</p>
						<ul>
							@for (interest of volunteer.interests; track interest) {
							<li>{{interest}}</li>
							}
						</ul>
						<p>Expertises:</p>
						<ul>
							@for (expertise of volunteer.expertises; track expertise) {
							<li>{{expertise}}</li>
							}
						</ul>
					</div>
				</div>

				@if(volunteer.isEntrepreneur != undefined){
				<div>
					<p>
						<strong>
							Has <u>{{volunteer.isEntrepreneur ? '' : 'not'}}</u> been an Entrepreneur
						</strong>
					</p>
				</div>
				}

			</div>
		</div>

	</div>
	<div class="col-lg-6 mb-2">
		<div class="bg-light rounded shadow-sm h-100">
			<div class="pt-2 ps-1">
				<h5>
					<span class="badge bg-secondary-subtle text-black px-3 py-2">
						Details
					</span>
				</h5>
			</div>

			<div class="p-3 pt-0">
				<table class="table table-borderless mb-4">
					<tbody>
						<tr>
							<th class="w-50">English Video:</th>
							<td>
								<div class="d-flex align-items-center">
									<span>{{volunteer.englishVideoStatus}}</span>
									@if(volunteer.hasEnVideo) {
									<div class="ms-2 play-icon" [class.color-eforall-blue]="volunteer.hasEnVideo"
										(click)="openVideoDialog(englishLanguageId)">
										<i class="fa-fw fa-circle-play fa-regular" role="button"></i>
									</div>
									}
								</div>
							</td>
						</tr>
						<tr>
							<th class="w-50">Spanish Video:</th>
							<td>
								<div class="d-flex align-items-center">
									<span>{{volunteer.spanishVideoStatus}}</span>
									@if(volunteer.hasEsVideo) {
									<div class="ms-2 play-icon" [class.color-eforall-blue]="volunteer.hasEsVideo"
										(click)="openVideoDialog(spanishLanguageId)">
										<i class="fa-fw fa-circle-play fa-regular" role="button"></i>
									</div>
									}
								</div>
							</td>
						</tr>
						<tr>
							<th class="w-50">Created:</th>
							<td>{{volunteer.createdUTC}}</td>
						</tr>
						<tr>
							<th class="w-50">Location:</th>
							<td>{{volunteer.placeAddress}}</td>
						</tr>
						<tr>
							<th class="w-50">Interview:</th>
							<td>{{volunteer.interviewDateUTC}}</td>
						</tr>
					</tbody>
				</table>
				<div>
					<h6>Weblinks:</h6>
					<ul [class.list-unstyled]="volunteer.socialLinks.length == 0">
						@for (socialLink of volunteer.socialLinks; track socialLink.webLinkTypeId) {
						<li><a href="{{socialLink.url}}" target="_blank">{{socialLink.type}}</a></li>
						} @empty {
						<p>No Weblinks</p>
						}
					</ul>
				</div>
				@if(!isLeadVolunteer()){
				<div class="mb-2">
					<common-button-row [center]="true">
						<button class="btn btn-standard" (click)="backToVolunteerDetails()">Back to Volunteer
							Details</button>
					</common-button-row>
				</div>
				}
			</div>
		</div>
	</div>
</div>
}